import DREDateRow from "./DREDateRow"
import { Button, DatePicker } from "@rio-cloud/rio-uikit"
import moment, { Moment } from "moment"
import useDREDate, { dreTypeOption } from "./useDREDate"
import { DashboardFilter } from "../../../types/dashboard"
import Card from "@rio-cloud/rio-uikit/Card"
import { DATE_LOCALE } from "../../../utils/dateRange"

interface PanelLoaderProps {
  label: string;
}


const DREDate = ({ requestFilters }: { requestFilters?: DashboardFilter }) => {
  const {
    dre,
    showBody,
    setShowBody,
    monthsLabels,
    getThreeMonthLabels,
    setMonthsLabels,
    dreLoadingNodes,
    toggleDRE,
    expandedDREItems,
    handleExpandDRENode,
    closeAllNodes,
    dreTypeSelect,
    setDreTypeSelect,
    dreTypeSelectOptions,
    startDate,
    hoveredId,
    setHoveredId,
    dreLoading
  } = useDREDate(requestFilters)

  const showDreDate = () => {
    setShowBody(!showBody)
    closeAllNodes()
  }

  const PanelLoader = ({ label }: PanelLoaderProps) => (
    <Card className="padding-30 display-flex justify-content-center align-items-center gap-10 min-height-150">
      <span className="rioglyph rioglyph-refresh spinning text-size-20 text-color-primary" />
      <span className="text-size-16 text-bold text-color-dark">Carregando {label}...</span>
    </Card>
  );

  return (
    <div className="padding-y-25 margin-top-25 margin-bottom-20 border border-top-only">
      <div className="margin-bottom-50">
        <button onClick={showDreDate} type="button" className="btn btn-default display-flex align-items-center justify-content-between gap-25">
          Comparativo de evolução
          <span className={`rioglyph  text-size-12 ${showBody ? 'rioglyph-chevron-up' : 'rioglyph-chevron-down'}`} aria-hidden="true">
          </span>
        </button>
      </div>
      {showBody ? (
        <>
          <div className="display-flex align-items-end gap-20 margin-bottom-20">
            <div className="width-250">
              <label htmlFor='3'>Selecione o período</label>
                <DatePicker
                  id='3'
                  value={moment(startDate)}
                  inputProps={{ placeholder: 'Selecione o período' }}
                  dateFormat='YYYY-MM'
                  timeFormat={false}
                  onChange={(result: Moment | string) => {
                    const date = moment(result);
                    const months = getThreeMonthLabels(date);
                    setMonthsLabels(months);
                    closeAllNodes();
                  }}
                  className="margin-0"
                  locale={DATE_LOCALE}
                />
            </div>
            <div className="form-group width-250 margin-0">
                <label htmlFor="select">Qual coluna deseja selecionar?</label>
                <select
                  className="form-control"
                  id="select"
                  value={dreTypeSelect}
                  onChange={(e => setDreTypeSelect(e.target.value as dreTypeOption))}
                >
                  <option>Selecione</option>
                  {dreTypeSelectOptions?.map(item => (
                      <option key={item.id} value={item.id}>{item.label}</option>
                  ))}
                </select>
            </div>
            {/* <div className="display-flex justify-content-end flex-1-1">
              <Button variant="outline" bsSize="sm" iconOnly>
                <span className="rioglyph rioglyph-download" aria-hidden="true" />
              </Button>
            </div> */}
          </div>

          {dreLoading ? PanelLoader({label: 'DRE'}) : null}

          {!dreLoading ? (
            <>
              <div className="display-flex justify-content-end padding-right-25 border border-bottom-only">
                <div className="width-150  display-flex justify-content-end">
                  <p className="margin-right-10">{monthsLabels[0]}</p>
                </div>
                <div className="width-150  display-flex justify-content-end">
                  <p className="margin-right-10">{monthsLabels[1]}</p>
                </div>
                <div className="width-150 display-flex justify-content-end">
                  <p className="margin-right-10">{monthsLabels[2]}</p>
                </div>
              </div>

              {dre?.lines.map((item, index) => (
                <DREDateRow
                  item={{...item, expandable: item.expandable || item.evolutionValues.expandable}}
                  key={item.compositeId ?? item.id}
                  lineType={item.lineType}
                  onToggle={toggleDRE}
                  expandedItems={expandedDREItems}
                  loadingNodes={dreLoadingNodes}
                  onExpandNode={handleExpandDRENode}
                  isLast={index === dre?.lines.length - 1}
                  depth={item.level}
                  dreTypeSelect={dreTypeSelect}
                  hoveredId={hoveredId}
                  setItemId={(id) => setHoveredId(id)}
                />
              ))}
            </>
          ) : null}
        </>
      ) : null}
    </div>
  )
}

export default DREDate
